import { useIntl, WithSkeleton } from '@capsicum/common';
import styled from 'styled-components';

import { useRouter } from '../../../hooks/router/useCustomRouter';
import { Label, SkeletonItem } from '../../atoms';
import { ChilizChainCircleIcon } from '../../icons/ChilizChainCircle';

export type NetworkFeeChipProps = {
	amount?: number | string;
	testID?: string;
};

const NetworkFeeChipSkeleton = () => {
	return <SkeletonItem height={28} width={210} />;
};

/**
 * @param amount - amount of chz
 **/
const NetworkFeeChipComponent = ({ amount = 1, testID }: NetworkFeeChipProps) => {
	const { $t } = useIntl();
	const { push } = useRouter();

	return (
		<S.StyledLabel
			icon={() => <ChilizChainCircleIcon height={16} width={16} />}
			label={`${$t('marketplace.estimatedNetworkFee', { amount })}`}
			testID={testID}
			variant="outlined"
		>
			<S.Button onClick={() => push('/nc-wallet/topup')}>{$t('marketplace.buyCHZ')}</S.Button>
		</S.StyledLabel>
	);
};

namespace S {
	export const StyledLabel = styled(Label)`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;

	export const Button = styled.div`
		${({ theme }) => theme.fonts.text.text4};
		color: ${({ theme }) => theme.colors.text.brand.enabled};
		cursor: pointer;
	`;
}

export const NetworkFeeChip = WithSkeleton(NetworkFeeChipComponent, NetworkFeeChipSkeleton);
